// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";


// import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCUa_kC9OY5kO-C9TEYgYjewVUM99CNacE",
  authDomain: "talkytoon.firebaseapp.com",
  projectId: "talkytoon",
  storageBucket: "talkytoon.firebasestorage.app",
  messagingSenderId: "378093249479",
  appId: "1:378093249479:web:357e7d55bd23097690efe2"
};

const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
const auth = getAuth(app);
const db = getFirestore(app);

const storage = getStorage(app);

export { auth, db, storage, collection, addDoc, ref, uploadBytes, getDownloadURL, firebaseConfig };
// Export auth and db for use in other parts of the app
// export const db = getFirestore(app);
